export default __webpack_public_path__ + "assets/d9b8f86fea166aee070d92a985468e4b.png";